import styles from './PulseDot.module.scss'

const PulseDot = () => <div className={styles.pulseDot} />

export default PulseDot
